import React from 'react'
import { YenSpan } from '../common/YenSpan'

export class HotSaleContainer extends React.PureComponent {
  render () {
    const { children } = this.props
    return <div className={'hot-sale__container'}>
      <div className={'hot-sale__container__title'}>热销</div>
      <div className={'hot-sale__wrapper'}>
        {children}
      </div>
    </div>
  }
}

export class HotSaleItem extends React.PureComponent {
  render () {
    const { src, price, ...props } = this.props
    return <div className={'hot-sale__item'} {...props}>
      <div className={'hot-sale__img'}>
        {
          src ? <img src={src} alt='' />
            : null
        }
      </div>
      <YenSpan smallSymbol color className={'hot-sale__price'}>{price}</YenSpan>
    </div>
  }
}
